import {sheetV1} from "@otto-ec/otto-components/sheet";

import {DesktopTopLevelItem, DesktopTopLevelItemFTNAV_2029, Flyout, FlyoutContent}
  from "./desktopElements";
import {TopBrands} from "./topBrands";
import {ShortcutCategories} from "./shortcutCategories";
import {observeMousemove} from "./mouseSpeedTracker";
import {isTouchDevice, initializeElement} from "./utils";
import {setSurveyCookie} from "./vertical-navigation-survey";

initializeElement(DesktopTopLevelItem);
initializeElement(DesktopTopLevelItemFTNAV_2029);
initializeElement(Flyout);
initializeElement(FlyoutContent);
initializeElement(TopBrands);
initializeElement(ShortcutCategories);

/*                                                                                 */
/*                   */
document.addEventListener("click", event => {
    const selectors = [DesktopTopLevelItem.customElement, DesktopTopLevelItemFTNAV_2029.customElement].join(",");
    if (!event.target.closest(".nav_desktop-global-navigation")) {
        event.target.querySelectorAll(selectors).forEach(
            (topLevelItem) => {
                if (topLevelItem.isActive()) topLevelItem.exitFlyout();
            }
        );
    }
});

if (!isTouchDevice()) observeMousemove();

sheetV1.events.close.subscribe((event) => {
    if(event.instance.dataset.navGlobalNavigationTracking) { /*                                 */
        if(event.action == "close-button") {
            event.instance.dispatchEvent(new CustomEvent("nav-sheet-close-via-button"));
        }
        if(event.action == "back-drop") {
            event.instance.dispatchEvent(new CustomEvent("nav-sheet-close-via-curtain"));
        }
        if(event.action == "back-button") {
            event.instance.dispatchEvent(new CustomEvent("nav-sheet-back"));
        }
    }
});

sheetV1.events.open.subscribe((event) => {
    if(event.instance.dataset.navGlobalNavigationTracking && event.action != "back-button") {
        event.instance.dispatchEvent(new CustomEvent("nav-sheet-open"));
    }

    if (event.instance.dataset.navGlobalNavigationSurvey) {
        setSurveyCookie();
    }
});
